export default __webpack_public_path__ + "static/media/reschedule.739cdb7e.svg";